// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f8f7537f","455":"7243da6a","977":"881f8adb"}[chunkId] + ".chunk.js";
};